import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
const SearchCount = t0 => {
  const $ = _c(10);
  const {
    title,
    indexClick,
    selectedOption,
    id,
    countOverride
  } = t0;
  const count = countOverride ?? 0;
  if (!count) {
    return null;
  }
  const isSelected = selectedOption === id;
  let t1;
  if ($[0] !== isSelected) {
    t1 = classNames("w-full bg-white text-center lg:text-left", {
      "font-bold": isSelected
    });
    $[0] = isSelected;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== count || $[3] !== id || $[4] !== indexClick) {
    t2 = () => {
      if (count) {
        indexClick(id);
      }
    };
    $[2] = count;
    $[3] = id;
    $[4] = indexClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `${title} (${count})`;
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand"><button type="button" className={t1} onClick={t2}>{t3}</button></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default SearchCount;